/**
 * Created by ChrisMuto on 7/12/17.
 */
import { cloneDeep, unset } from "lodash";

/**
 * Clone an object while omitting certain items in the path. Especially useful
 * for updating the state without modifying the state
 *
 * @param object
 *         A javascript object
 * @param omitPath
 *           A path within the object. A path can be represented as a string or array
 *
 *           string format: deepCloneAndOmitAtPath({a:[b:{c:7}]}, 'a[0].b.c') => { 'a': [{ 'b': {} }] };
 *           array format:                               ['a',0,'b','c']
 *
 * @returns {*} A clone of the object, omitting the path you passed
 */
export function deepCloneAndOmitAtPath(object, omitPath) {
    const newObject = cloneDeep(object);
    unset(newObject, omitPath);
    return newObject;
}

export function deepCloneAndOmitAtIndex(array, index) {
    const newArray = cloneDeep(array);
    newArray.splice(index, 1);
    return newArray;
}



// WEBPACK FOOTER //
// ./src/helpers/state.js